import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import {getStoreConfig} from "../config";
Vue.use(Vuex);

let thePhone = null;
const storeConfig = getStoreConfig();

if (localStorage.getItem("cart")) {
  /*defaultCart = JSON.parse(localStorage.getItem("cart"));*/
}
if (localStorage.getItem("phone")) {
  thePhone = localStorage.getItem("phone");
}
export default new Vuex.Store({
  state: {
    categories: [],
    cart: [],
    offerBody: null,
    selectedOfferId: null,
    selectedOfferPrice: null,
    fixedSelectedPrice: null,
    offerBodyLoading: false,
    showPopUp: false,
    quantity: 1,
    askForPhone: false,
    phone: thePhone,
    setUserData: {},
    storedItem: {},
    getUserData: localStorage.getItem("userData")
  },
  mutations: {
    setItemToCart(state, payload) {
      state.cart.push(payload);
    },
    setQuantity(state, payload) {
      state.quantity = payload;
    },
    removeItem(state, payload) {
      state.cart = state.cart.filter(item => {
        return item.offer_id != payload && item.id != payload;
      });
    },
    setOfferBody(state, payload) {
      state.offerBody = payload;
      state.quantity = 1;
      state.selectedOfferPrice = payload["initial_price"];
      state.fixedSelectedPrice = payload["initial_price"];
    },
    setShowPopUp(state) {
      state.showPopUp = true;
    },
    setHidePopUp(state) {
      state.showPopUp = false;
    },
    async plusQuantity(state) {
      state.quantity++;
      let formData = new FormData();
      formData.append("action", "get_item_price_for_quantity");
      formData.append("offer_id", state.selectedOfferId);
      formData.append("quantity", state.quantity);
      let response = await axios.post("", formData);
      if (response.data.price) {
        state.selectedOfferPrice = response.data.price;
      } else {
        state.selectedOfferPrice = +state.fixedSelectedPrice * state.quantity;
      }
    },
    async minusQuantity(state) {
      if (state.quantity > 1) {
        state.quantity--;
        let formData = new FormData();
        formData.append("action", "get_item_price_for_quantity");
        formData.append("offer_id", state.selectedOfferId);
        formData.append("quantity", state.quantity);
        let response = await axios.post("", formData);
        if (response.data.price) {
          state.selectedOfferPrice = response.data.price;
        } else {
          state.selectedOfferPrice = +state.fixedSelectedPrice * state.quantity;
        }
      }
    },
    hideAskPhone(state) {
      state.askForPhone = false;
    },
    setPhone(state, payload) {
      state.setUserData = payload;
      state.getUserData = payload;
      localStorage.setItem(
        "userData",
        JSON.stringify({
          phone: payload.phone,
          name: payload.name,
          address: payload.address
        })
      );
      state.getUserData = state.setUserData;
    }
  },
  actions: {
    addPhone() {
      let formData = new FormData();
      formData.append(
        "action",
        "add_to_cart_by_phone_offerid_quantity_address"
      );
      formData.append("phoneone", this.state.setUserData.phone);
      formData.append("quantity", this.state.quantity);
      formData.append("name", this.state.setUserData.name);
      formData.append("address", this.state.setUserData.address);
      formData.append("offer_id", Number(this.state.storedItem.id));
      axios.post(``, formData).then(() => {
        //get cart items
        let formData = new FormData();
        let userData = {};
        if (typeof this.state.getUserData == "string") {
          userData = JSON.parse(this.state.getUserData);
        } else {
          userData = this.state.getUserData;
        }
        if (userData) {
          formData.append("action", "get_cart_attributes");
          formData.append("cartPhoneNumber", userData.phone);
          axios.post("", formData).then(res => {
            this.state.cart = res.data.items;
          });
        }
      });

      //animation
      let element = document.getElementById("shopcard");
      let element2 = document.getElementById("shopcard2");
      setTimeout(function() {
        element.classList.add("animated");
        element.classList.add("bounce");
        element2.classList.add("animated");
        element2.classList.add("bounce");
      }, 500);
    },
    show() {
      this.state.showPopUp = true;
    },
    async addToCart(context, { item, quantity }) {
      let theItem = item;
      theItem.selling_price = item.first_offer_price;
      theItem.item_image_path = item.image_path;
      let userData = {};
      this.state.storedItem = theItem;
      if (typeof this.state.getUserData == "string") {
        userData = JSON.parse(this.state.getUserData);
      } else {
        userData = this.state.getUserData;
      }

      if (this.state.getUserData) {
        let carts = this.state.cart;

        let formData = new FormData();
        formData.append(
          "action",
          "add_to_cart_by_phone_offerid_quantity_address"
        );
        formData.append("phoneone", userData.phone);
        formData.append(
          "quantity",
          quantity?.toString() ?? this.state.quantity
        );
        formData.append("name", userData.name);
        formData.append("address", userData.address);
        formData.append("offer_id", Number(this.state.storedItem.id));

        await axios.post(``, formData).then(() => {
          //get cart items
          let formData = new FormData();
          let userData = {};
          if (typeof this.state.getUserData == "string") {
            userData = JSON.parse(this.state.getUserData);
          } else {
            userData = this.state.getUserData;
          }
          if (userData) {
            formData.append("action", "get_cart_attributes");
            formData.append("cartPhoneNumber", userData.phone);
            axios.post("", formData).then(res => {
              this.state.cart = res.data.items;
            });
          }
        });

        //animation
        let element = document.getElementById("shopcard");
        let element2 = document.getElementById("shopcard2");

        setTimeout(function() {
          element.classList.add("animated");
          element.classList.add("bounce");
          element2.classList.add("animated");
          element2.classList.add("bounce");
        }, 500);
      } else {
        this.state.askForPhone = true;
      }

      //context.commit('setItemToCart', item)
    },
    async removeFromCart(context, item) {
      // let carts = this.state.cart
      // carts = carts.filter(cart=>{
      //     return cart.id != item
      // })
      // localStorage.setItem('cart', JSON.stringify(carts))

      let userData = {};
      if (typeof this.state.getUserData == "string") {
        userData = JSON.parse(this.state.getUserData);
      } else {
        userData = this.state.getUserData;
      }

      let formData = new FormData();

      formData.append("action", "delete_from_cart");
      formData.append("cartPhoneNumber", userData.phone);
      formData.append("offerId", Number(item));
      const { data } = await axios.post("", formData);
      if (data.success) {
        context.commit("removeItem", item);
      }
    },
    getOfferBody(context, id) {
      //store offer id
      this.state.selectedOfferId = id;

      //get offer
      let formData = new FormData();
      formData.append("action", "get_offer_by_id");
      formData.append("offer_id", id);
      this.state.offerBodyLoading = true;
      axios
        .post("", formData)
        .then(res => {
          let handleoffer = res.data;
          //handle cover img
          handleoffer["offer_image_path"] = storeConfig.rootUrl + handleoffer["offer_image_path"];

          //handle offer body
          let regex = new RegExp("../img-uploads", "g");
          handleoffer["offer_body"] = handleoffer["offer_body"].replace(
            regex,
            `${storeConfig.rootUrl}img-uploads`
          );
          context.commit("setOfferBody", handleoffer);
          this.state.offerBodyLoading = false;
          document.title = res.data.offer_name;
          setTimeout(() => {
            let isItemInCard = this.state.cart.find(product => {
              return product.offer_id == id;
            });
            console.log(isItemInCard);
            if (isItemInCard) {
              this.state.quantity = isItemInCard.quantity;
            }
          }, 500);
        })
        .catch(() => {
          this.state.offerBodyLoading = false;
        });
    },

    getCardItems() {
      let formData = new FormData();
      let userData = {};
      if (typeof this.state.getUserData == "string") {
        userData = JSON.parse(this.state.getUserData);
      } else {
        userData = this.state.getUserData;
      }
      if (userData) {
        formData.append("action", "get_cart_attributes");
        formData.append("cartPhoneNumber", userData.phone);
        axios.post("", formData).then(res => {
          if (res.data.items) {
            this.state.cart = res.data.items;
          }
        });
      }
    },
    removeUserInfo() {
      localStorage.removeItem("userData");
      this.state.getUserData = {};
      location.reload();
    }
  }
});
